import getScaledImageSource from './getScaledImageSource';
export default getScaledImageSource;